import { NAME } from './constants';

export const APPEND_CONTACTS = `${NAME}/APPEND_CONTACTS`;
export const RESET = `${NAME}/RESET`;
export const RESET_SELECTED_CONTACTS = `${NAME}/RESET_SELECTED_CONTACTS`;
export const SET_CONTACTS = `${NAME}/SET_CONTACTS`;
export const SET_QUICK_FILTER = `${NAME}/SET_QUICK_FILTER`;
export const TOGGLE_CONTACT = `${NAME}/TOGGLE_CONTACT`;
export const SET_SORT = `${NAME}/SET_SORT`;
export const SET_RESET_RELATED_SECTIONS = `${NAME}/SET_RESET_RELATED_SECTIONS`;
